import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-image',
  templateUrl: './contact-image.component.html',
  styleUrls: ['./contact-image.component.css']
})
export class ContactImageComponent implements OnInit {

  _show = false;

  constructor() { }

  ngOnInit(): void {
  }

  open() {
    this._show = true;
  }

  close() {
    this._show = false;
  }

  openWhatsapp() {
    window.open('https://wa.me/qr/VTX6KLLLQ23RL1')
  }

}
